<!-- <div *ngIf="Form != null && !Form.valid"> -->
<div [@slideInOut]="showError()? 'in':'out'" style="border-color: red; border-style: solid;">
  @for (e of formErrors; track e) {
    <div style="color: red;" class="has-text-centered">
      {{e}}
    </div>
  }
</div>